module.exports = __webpack_public_path__ + "assets/img/icon-logo-2.badf14fd.png";